import {axiosGet, urlGenerator} from "../../../common/Helper/AxiosHelper";
import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {formatDateToLocal} from "../../../common/Helper/Support/DateTimeHelper";
import {HotelFilterMixin} from "./FilterMixin";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";

export default {
    mixins: [HelperMixin, DatatableHelperMixin, HotelFilterMixin],
    data() {
        return {
            urlGenerator,
            options: {
                name             : this.$t('special_cleaning'),
                url              : `${TENANT_BASE_URL}app/hotel/special-cleaning`,
                showHeader       : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : this.$t('actions'),
                        type     : 'action',
                        key      : 'id',
                        isVisible: true
                    },
                    {
                        title    : this.$t('hotel'),
                        type     : 'custom-html',
                        key      : 'hotel',
                        isVisible: true,
                        modifier : (value) => value.name
                    },
                    {
                        title    : this.$t('room'),
                        type     : 'custom-html',
                        key      : 'room',
                        isVisible: true,
                        modifier : (room) => {
                            return room ? room.number : '';
                        }
                    },
                    {
                        title    : this.$t('option'),
                        type     : 'custom-html',
                        key      : 'option',
                        isVisible: true,
                        modifier : (option) => {
                            return option ? option.name : '';
                        }
                    },
                    {
                        title    : this.$t('cleaning_date'),
                        type     : 'custom-html',
                        key      : 'cleaning_date',
                        isVisible: true,
                        modifier : (value) => value ? formatDateToLocal(value) : 'N/A'
                    },
                    {
                        title    : this.$t('check_at'),
                        type     : 'custom-html',
                        key      : 'check_at',
                        isVisible: true,
                        modifier : (value) => value ? formatDateToLocal(value) : 'N/A'
                    },
                    {
                        title    : this.$t('created'),
                        type     : 'custom-html',
                        key      : 'created_at',
                        isVisible: true,
                        modifier : (value) => value ? formatDateToLocal(value) : 'N/A'
                    },
                ],
                filters          : [
                    {
                        title         : this.$t('hotel'),
                        type          : "multi-select-filter",
                        key           : "hotels",
                        option        : [],
                        listValueField: 'name',
                        permission    : !!this.$can('view_hotel_list')
                    },
                    {
                        title : this.$t('date'),
                        type  : "range-picker",
                        key   : "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                ],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'default',
                actions          : [
                    {
                        title   : this.$t('edit'),
                        icon    : 'edit',
                        type    : 'modal',
                        modifier: row => this.$can('update_hotel_special_cleaning')
                    },
                    {
                        title    : this.$t('delete'),
                        icon     : 'trash-2',
                        type     : 'modal',
                        component: 'app-confirmation-modal',
                        modalId  : 'app-confirmation-modal',
                        url      : `${TENANT_BASE_URL}app/hotel/special-cleaning/`,
                        name     : 'delete',
                        modifier : row => this.$can('update_hotel_special_cleaning')
                    }
                ],
            }
        }
    },
}